<!--乐生活限时抢购/免费体验列表-->
<template>
    <section id="volumeList">
        <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" @bottom-status-change="handleBottomChange" :bottom-all-loaded="allLoaded" ref="loadmore" :auto-fill="false">
                <ul class="list" >
                    <li v-for="(val, key) in Data" :key="key">
                        <router-link :to="val.shopGoodsId+'/?mallId='+mallId">
                            <img :src="val.picUrl" alt="">
                            <h3>{{val.name}} <span class="fr" v-if="saleWay == 4">免费体验</span>
                                <span class="fr price" v-else-if="saleWay == 3">￥{{val.qty/100}} <s>￥{{val.priceOrigin/100}}</s></span>
                            </h3>
                            <p v-if="saleWay > 0&&saleWay < 6">{{saleWay|typeinfo}}：{{val.limitStartTime | dateFormat('YYYY-MM-DD')}}至{{val.limitEndTime | dateFormat('YYYY-MM-DD')}}</p>
                        </router-link>
                    </li>
                </ul>
                <div slot="bottom" class="mint-loadmore-bottom">
                    <span v-show="bottomStatus !== 'loading'" :class="{ 'is-rotate': bottomStatus === 'drop' }">加载更多</span>
                    <span v-show="bottomStatus === 'loading'">
                <mt-spinner type="snake"></mt-spinner>
              </span>
                </div>
            </mt-loadmore>
    </section>
</template>
<script>
    import { fetchVolumeList} from '../../common/api/homePage';
    export default {
    data() {
        return {
            Data:[],　　//每次加载累加后的总数据
            allLoaded: false, 　　//若为真，则 bottomMethod 不会被再次触发
            num:0,　　//num为1时表示刷新或第一次加载，每加载一次增加1，刷新时默认为0
            mallId : this.$route.query.mallId,
            saleWay:this.$route.params.saleWay,
            bottomStatus: ''
        }
    },
        filters: {
            typeinfo (val){
                switch (val) {
                    case 1:
                        return '普通销售';
                        break;
                    case 2:
                        return '优惠促销';
                        break;
                    case 3:
                        return '精选优惠';
                        break;
                    case 4:
                        return '免费体检';
                        break;
                    case 5:
                        return '团购';
                        break;
                }
            }
        },
    methods:{
        //下拉刷新
        loadTop() {　　
            this.num=1;
            this.update(1,'top');
            this.allLoaded = false;
        },
        handleBottomChange(status) {
            this.bottomStatus = status;
        },

        //上拉加载　
        loadBottom() {　　　　　
            this.num++;
            this.update(this.num,'bottom');
        },

        //每次触发上拉加载或下拉刷新时触发的数据接口
        update(pageNo,type){　
            fetchVolumeList(this.mallId,this.saleWay,pageNo).then((ret) => {
                if(ret.data.code==0){
                    if(pageNo==1){　　//如果偏移量为1说明是下拉刷新所以Data为刚加载出来的数据
                        this.Data=ret.data.data.goodsPage;
                    }else{　　//偏移量大于0，说明为上拉加载，Data为前面锁加载出来数据的累加
                        if(ret.data.data.goodsPage.length<1){
                            this.allLoaded = true;
                            return;
                        }
                        this.Data.concat(ret.data.data.goodsPage);
                    }
                }
                //通过传过来的type值不同分辨上拉加载或下拉刷新
                if(type=='top'){
                    this.$refs.loadmore.onTopLoaded();
                }else if(type=='bottom'){
                    this.$refs.loadmore.onBottomLoaded();
                }
            })
        }


    },
    updated(){　　//只要数据变化就会判断一次数据是否已读过，判断标记的显隐
    },
    created(){　　//打开页面首先自动获取一次数据
        this.num++;
        fetchVolumeList(this.mallId,this.saleWay,this.num).then((ret) => {
            if(ret.data.code ==0 ){
                this.Data=ret.data.data.goodsPage;
            }
        })
    }
    }
</script>

<style lang="scss">
    @import '../../assets/css/px2rem.scss';
    #volumeList{
        /*上拉刷新必备属性*/
        overflow: scroll;
        ul{
            background-color: #F6F6F6;
            li{
                background-color: #fff;
                height:px2rem(266);
                padding:px2rem(12);
                padding-bottom: 0;
                margin-bottom: px2rem(12);
                a{
                    display: block;
                    width: 100%;
                    height:100%;
                    img{
                        width:100%;
                        height:px2rem(160);
                        margin-bottom: px2rem(19);
                    }
                    h3{
                        font-size: px2rem(16);
                        font-weight: bold;
                        color: #333;
                        line-height: px2rem(22);
                        margin-bottom: px2rem(25);
                        span{
                            font-weight: normal;
                            color:#FF4A2A;
                            font-size: px2rem(14);
                            line-height: px2rem(20);
                        }
                        span.price{
                            font-size: px2rem(24);
                            line-height: px2rem(33);
                            s{
                                font-size: px2rem(14);
                                color: #999;
                                line-height: px2rem(20);
                            }
                        }
                    }
                    p{
                        font-size: px2rem(12);
                        color: #999;
                    }
                }
            }
        }
    }

</style>
